import Div from "@jumbo/shared/Div";
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import { Download, RemoveRedEye } from "@mui/icons-material";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import { LoadingButton } from "@mui/lab";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
// import PartStoneStatus from './PartStoneStatus'; // Adjust the path as necessary




import {
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
  Tooltip,
  DialogActions,
  Fab,
  Chip,
  Autocomplete,
  Box,
  Badge,
  Avatar,
  Card,
  IconButton,
  Pagination,
  TextareaAutosize,
  Slide,
  AppBar,
  Toolbar,
  List,
  ListItemButton,
  ListItemText,
  Modal,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import jwtAuthAxios from "app/services/auth/jwtAuth";
import NoDataPlaceholder from "app/shared/NoDataPlaceholder";
import TableView from "app/shared/Tableview/Tableview";
import TableSkeleton from "app/shared/widgets/TableSkeleton";
import { Formik, Form, Field } from "formik";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
// import { PDFDownloadLink, Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import styled from "@emotion/styled";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { BACKEND_APP_URL } from "app/utils/constants/paths";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import JumboBookmark from "@jumbo/components/JumboBookmark";
import Span from "@jumbo/shared/Span";
import { DataGrid } from "@mui/x-data-grid";
import { ExcelTransactionExp } from "app/shared/ExcelGenerate/ExcelGenerateForSearch";
import { number } from "prop-types";
import JumboConfirmDialog from "@jumbo/components/JumboConfirmDialog";
import { ItemBlock } from "app/utils/appHelpers";

import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";

import EditSaleTXN from "./editOutwardTxn";
import CloseIcon from "@mui/icons-material/Close";
import SaleReturn from "./SaleReturn";
export function formatDate(inputDate) {
  const dateObject = new Date(inputDate);
  const day = String(dateObject.getDate()).padStart(2, "0");
  const month = String(dateObject.getMonth() + 1).padStart(2, "0");
  const year = dateObject.getFullYear();
  const formattedDate = `${day}/${month}/${year}`;
  return formattedDate;
}
export function daysSince(inputDate) {
  // Parse the input date string into a Date object (assuming MM/DD/YYYY format)
  const inputDateTime = new Date(inputDate);
  // Calculate the time difference in milliseconds
  const timeDifference = new Date() - inputDateTime;
  // Convert milliseconds to days
  const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  return daysDifference;
}

function PartStoneStatus() {
  const [EditSaleDialoge, setEditSaleDialoge] = useState(false);
  const [trParty, setTrParty] = useState([]);
  const [Data, setData] = useState([]);
  const [totalData, settotalData] = useState({});
  const [DefaultDialoge, setDefaultDialoge] = useState(true);
  const [MData, setMData] = useState([]);
  // const [FormData, setFormData] = useState({})
  const [Memonumber, setMemonumber] = useState([]);
  const [value, setValue] = React.useState(0);
  const [currentType, setCurrentType] = useState(null);
  const [selectedtrParty, setSelectedTrParty] = useState(null);
  const [selectedMemoNo, setSelectedMemoNo] = useState(null);
  const [SelectedStone, setSelectedStone] = useState([]);
  const [SelectedTrID, setSelectedTrID] = useState([]);
  const [SelectedStoneDetail, setSelectedStoneDetail] = useState([]);
  // const [generateTextInvoiceDIaloge, setGenerateTextInvoiceDIaloge] = useState(true)
  const [pdfData, setPdfData] = useState(null);
  const jumboco = useJumboAuth();
  const [formval, setFormval] = useState({
    selectedParties: [],
    startDate: "",
    endDate: "",
    fl_p: false,
    salesmanData: "",
    transactionType: "",
  });
  const [saleReturnStatus, setSaleReturnStatus] = useState(false);
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(!open);
  const swal = useSwalWrapper();
  const fetchtrPartydata = useCallback(() => {
    setSelectedStone([]);
    jwtAuthAxios
      .get(
        "master/helper?party=1&trtype=OUTWARD&salesman=1&paramsData=SHIPPEDBY&term=1&PVID=Sold&curr=1&tax=VAT_ON_SALES&leadgerdetail=22&inventoryType=1"
      )
      .then((res) => {
        setTrParty(res.data.data);
        setCurrentType("DETAIL");
      });
  });
  useEffect(() => {
    let seData = MData?.filter((st) => SelectedStone?.includes(st.FL_STONE_ID));
    setSelectedStoneDetail(seData);
    // console.log(SelectedStone);
  }, [SelectedStone]);
  const location = useLocation();
  // console.log(location);
  const fetchtrdata = () => {
    setPdfData(null);
    setMData([]);
    setSelectedStone([]);
    jwtAuthAxios
      .get(
        "transation/stoneByParty?partyId=" +
          selectedtrParty +
          "&trtype=" +
          value +
          "&MemoNO=" +
          selectedMemoNo
      )
      .then((res) => {
        let sData = res.data?.data?.sort((a, b) =>
          a.FL_STONE_ID > b.FL_STONE_ID ? 1 : -1
        );
        setMData(sData);
      })
      .catch(() => {
        swal.fire({
          icon: "error",
          text: "something Went Wrong",
        });
      });
  };
  const fetchMemoNumber = () => {
    setMemonumber([]);
    setSelectedStone([]);
    jwtAuthAxios
      .get(
        "transation/GetMemoNumber?partyId=" +
          selectedtrParty +
          "&trtype=" +
          value
      )
      .then((res) => {
        // let ManageStoneDisc = res.data?.data?.sort((a, b) => (a.FL_STONE_ID > b.FL_STONE_ID ? 1 : -1));
        setMemonumber(res.data?.data);
      })
      .catch(() => {
        swal.fire({
          icon: "error",
          text: "something Went Wrong",
        });
      });
  };
  useEffect(() => {
    fetchtrPartydata();
  }, []);
  useEffect(() => {
    setMemonumber([]);
    if (value != 33) {
      setSelectedMemoNo(null);
      selectedtrParty && FetchSaleData();
    } else {
      selectedMemoNo ? fetchtrdata() : fetchMemoNumber();
    }
  }, [selectedtrParty]);
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const handleStoneSelect = (stone) => {
    // console.log(stone);
    if (SelectedStone.indexOf(stone) === -1) {
      // If the stone is not in SelectedStone, add it
      setSelectedStone([...SelectedStone, stone]);
    } else {
      // If the stone exists in SelectedStone, remove it
      const updatedStones = SelectedStone?.filter((s) => s !== stone);
      setSelectedStone(updatedStones);
    }
  };
  useEffect(() => {
    setCurrentType("DETAIL");
    setMData(null);
    // setData(null)
    if (value != 33) {
      setSelectedMemoNo(null);
      selectedtrParty && FetchSaleData();
    } else {
      selectedMemoNo ? fetchtrdata() : fetchMemoNumber();
    }
  }, [value]);
  useEffect(() => {
    selectedMemoNo && fetchtrdata();
  }, [selectedMemoNo]);

  const columns = [
    {
      accessorKey: "Type",
      header: "Type",
      size: 50,
      Cell: (params) => (
        <Badge
          overlap="circular"
          variant="dot"
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          sx={{
            ".MuiBadge-badge": {
              border: "2px solid #FFF",
              height: "10px",
              width: "10px",
              borderRadius: "50%",
              bgcolor:
                params.row?.original?.FL_P == "Y"
                  ? "#757575"
                  : params.row?.original?.TRTYPE[0] == "M"
                  ? "info.main"
                  : "success.main",
            },
          }}
        >
          <Avatar
            sx={{
              width: 25,
              height: 25,
              fontSize: "14px",
            }}
          >
            {params.row?.original?.TRTYPE[0]}
          </Avatar>
        </Badge>
      ),
    },
    { accessorKey: "PARTYNAME", header: "Party Name", size: 180 },
    { accessorKey: "FL_DIAMOND_TYPE", size: 80, header: "Salesman" },
    { accessorKey: "SALES_MAN", size: 80, header: "Salesman" },
    { accessorKey: "TERM", size: 80, header: "Term" },
    {
      accessorKey: "TRDATE",
      size: 100,
      header: "Date",
      Cell: (params) => formatDate(params.row.original.TRDATE),
    },
    {
      accessorKey: "DAYS",
      size: 100,
      header: "Days",
      Cell: (params) => `${daysSince(params.row.original.TRDATE)} Days`,
    },
    {
      accessorKey: "TRNO",
      header: "TR.NO",
      size: 140,
      Cell: (params) =>
        params.row?.original.FL_TRANS_TYPE == "33" &&
        jumboco?.rights?.edit == 1 ? (
          <Link
            to={`/outward/${params.row.original?.FL_TRANS_TYPE}/${params.row.original?.FL_PARTY_CODE}/${params.row.original?.FL_TRANS_NO}`}
            target="_blank"
          >
            {params.row.original?.FL_BILL_NO}
          </Link>
        ) : (
          <Typography variant={"body1"}>
            {params.row.original?.FL_BILL_NO}
          </Typography>
        ),
    },
    { accessorKey: "PCS", size: 80, header: "PCS" },
    {
      accessorKey: "CTS",
      size: 80,
      header: "CTS",
      Cell: (params) => {
        return (params.row.original?.CTS || 0)?.toFixed(2);
      },
    },
    { accessorKey: "FL_CONV_RATE", size: 80, header: "Rate" },
    { accessorKey: "SHIP", size: 80, header: "Ship By" },
    {
      accessorKey: "FFL_AMT1",
      size: 100,
      header: "AMT($)",
      Cell: (params) => {
        return params.row.original?.FFL_AMT1?.toFixed(2) || 0;
      },
    },
    {
      accessorKey: "FFL_AMT2",
      size: 100,
      header: "AMT(RMB)",
      Cell: (params) => {
        return params.row.original?.FFL_AMT2?.toFixed(2) || 0;
      },
    },
    {
      accessorKey: "Action",
      header: "Action",
      type: "number",
      Cell: (params) => {
        return params.row.original.TRTYPE == "Memo" &&
          jumboco?.rights?.print == 1 ? (
          <Button
            sx={{ minWidth: 92 }}
            onClick={() => {
              window.open(
                BACKEND_APP_URL +
                  "rp/GenerateMemo?memono=" +
                  params?.row.original?.FL_TRANS_NO
              );
            }}
            disableElevation
            variant={"contained"}
            size={"small"}
          >
            Memo PDF
          </Button>
        ) : params.row.original.TRTYPE == "Sold" ? (
          <>
            {jumboco?.rights?.print == 1 && (
              <Tooltip
                title="Invoice"
                onClick={() => {
                  window.open(
                    BACKEND_APP_URL +
                      "rp/GenerateInvoice?INNO=" +
                      params?.row?.original.FL_TRANS_NO
                  );
                }}
              >
                <Fab color="primary" variant="contained" size="small">
                  <ReceiptOutlinedIcon />
                </Fab>
              </Tooltip>
            )}
            {jumboco?.rights?.edit == 1 && (
              <Tooltip
                title="Edit"
                onClick={() =>
                  saleEditHandler({
                    trno: params?.row?.original.FL_TRANS_NO,
                    trtype: params?.row?.original.FL_TRANS_TYPE,
                  })
                }
              >
                <Fab
                  sx={{ ml: 1 }}
                  color="primary"
                  variant="contained"
                  size="small"
                >
                  <EditOutlinedIcon />
                </Fab>
              </Tooltip>
            )}
          </>
        ) : null;
      },
    },
    // const columns = [
    //   { field: 'Type', headerName: 'Type', width:50, renderCell: (params) => (
    //     <Badge overlap="circular" variant="dot"
    //                                anchorOrigin={{
    //                                    vertical: 'bottom',
    //                                    horizontal: 'right',
    //                                }}
    //                                sx={{
    //                                    '.MuiBadge-badge': {
    //                                        border: '2px solid #FFF',
    //                                        height: '10px',
    //                                        width: '10px',
    //                                        borderRadius: '50%',
    //                                        bgcolor: params.row?.FL_P == 'Y' ? "#757575" : params.row?.TRTYPE[0] =='M'?"info.main": "success.main"
    //                                    }
    //                                }}
    //                         >
    //                             <Avatar
    //                                 sx={{
    //                                     width: 25,
    //                                     height: 25,
    //                                     fontSize: '14px'
    //                                 }}
    //                             >{params.row.TRTYPE[0]}</Avatar>
    //                         </Badge>)},{ field: 'PARTYNAME', headerName: 'Party Name',width:180},
    //                         { field: 'SALES_MAN', width:100, headerName: 'Salesman'},
    //                         { field: 'TERM',  headerName: 'Term'},
    //                         { field: 'TRDATE',  headerName: 'Date',renderCell:(params)=>formatDate(params.row.TRDATE)},
    //                         { field: 'DAYS', width:100, headerName: 'Days',renderCell:(params)=>`${daysSince(params.row.TRDATE)} Days`},
    //                         { field: 'TRNO',  headerName: 'TR.NO',width:140, renderCell: (params)=>(params.row?.FL_TRANS_TYPE =='33' && jumboco?.rights?.edit == 1) ? <Link to={`/outward/${params.row?.FL_TRANS_TYPE}/${params.row?.FL_PARTY_CODE}/${params.row?.FL_TRANS_NO}`} target='_blank'>{params.row?.FL_BILL_NO}</Link> :<Typography variant={"body1"} >{params.row?.FL_BILL_NO}</Typography>},
    //                         { field: 'PCS',  headerName: 'PCS',type:"number"},
    //                         // { field: 'CTS',  headerName: 'CTS',type:"number",renderCell:(params)=>params.value?.toFixed(2) || ''},
    //                         { field: 'FL_CONV_RATE',  headerName: 'Rate',type:"number"},
    //                         { field: 'FFL_AMT1',  headerName: 'AMT($)',type:"number", renderCell:(params)=>params.row?.FFL_AMT1?.toFixed(2)},
    //                         { field: 'FFL_AMT2',  headerName: 'AMT(RMB)',type:"number", renderCell:(params)=>params.row?.FFL_AMT2?.toFixed(2)},
    //                         // { field: 'SHIP',  headerName: 'Ship By'},
    //                         { field: 'Action', headerName: 'Action',type:"number",renderCell:(params)=>{return params.row.TRTYPE== 'Memo' ?<Button sx={{minWidth: 92}} onClick={()=>{ window.open(BACKEND_APP_URL+'rp/GenerateMemo?memono='+params?.row?.FL_TRANS_NO)}} disableElevation variant={"contained"} size={"small"} >
    //                             Memo PDF
    //                         </Button>:params.row.TRTYPE== 'Sold' ? <Button sx={{minWidth: 92}} onClick={()=>{ window.open(BACKEND_APP_URL+'rp/GenerateInvoice?INNO='+params?.row?.FL_TRANS_NO)}} disableElevation variant={"contained"} size={"small"} >
    //                             Invoice
    //                         </Button>: null}},
  ];

  const FetchSaleData = useCallback(async () => {
    setSelectedStone([]);
    await jwtAuthAxios
      .get(`transation/GetSaleTransactionMas?partyId=${selectedtrParty}`)
      .then((res) => setData(res.data.data))
      .catch((e) => {
        swal.fire({
          icon: "error",
          text: "Internal server Error",
        });
      });
  }, [selectedtrParty]);
  const memoReturnHandler = useCallback(async () => {
    let StoneDetaildata = MData?.filter((d) =>
      SelectedStone.includes(d.FL_STONE_ID)
    );
    console.log(StoneDetaildata);
    let StoneData = StoneDetaildata.map(({ FL_SRNO, CARATSFL_STONE_ID }) => ({
      FL_SRNO,
      CARATSFL_STONE_ID,
    }));
    await jwtAuthAxios
      .post("transation/polishMemoreturn", {
        StoneData: StoneData,
        Party: selectedtrParty,
        trno: selectedMemoNo,
      })
      .then((res) => {
        swal.fire({
          icon: "success",
          text: res.data.message,
        });
        fetchtrdata();
      })
      .catch((e) => {
        swal.fire({
          icon: "error",
          text: "Internal server Error",
        });
      });
  }, [SelectedStone, selectedtrParty, Data]);

  const handleDetailView = async (e) => {
    // console.log(e);
    setData(null);
    await jwtAuthAxios
      .post("transation/transactionDetails", { P_NO: e.NO, P_TYPE: e.TYPE })
      .then((res) => {
        // console.log(res.data.data);
        setData(res.data.data);
        setCurrentType("DETAILAll");
      })
      .catch(() => {
        alert("internal server error");
      });
    // let Data = await getTransactionDetail(`pid=${e.ID}`)
    // setData(Data)
  };

  const handlediscChang = async (e, stone, type) => {
    let tmpStoneData = stone;
    let targetData = e.target?.id.split("-");
    // console.log(targetData);
    // console.log(e.target.id);
    if (type == 0) {
      let disc = e.target.value;
      tmpStoneData = { ...tmpStoneData, MDISC: disc };
    } else if (type == 1) {
      tmpStoneData = {
        ...tmpStoneData,
        MDISC: 100 - (e.target.value * 100) / stone.FL_RAP_PRICE_US,
      };
    } else if (type == 2) {
      let tmpAMT = e.target.value / stone.CARATS;
      tmpStoneData = {
        ...tmpStoneData,
        MDISC: 100 - (tmpAMT * 100) / stone.FL_RAP_PRICE_US,
      };
    }
    let ManageStoneDisc = MData?.filter(
      (sd) => sd.FL_STONE_ID !== stone.FL_STONE_ID
    );
    let tmpprice =
      stone.FL_RAP_PRICE_US -
      (stone.FL_RAP_PRICE_US * tmpStoneData.MDISC) / 100;
    let FinalObj = {
      ...tmpStoneData,
      mPrice: tmpprice,
      mamt: tmpprice * stone.CARATS,
    };
    ManageStoneDisc.push(FinalObj);
    // console.log('type',type != 1 ,typeof(type));
    // console.log(FinalObj.mPrice?.toFixed(2));
    // Sort the array by the FL_STONE_ID property in ascending order
    ManageStoneDisc.sort((a, b) => (a.FL_STONE_ID > b.FL_STONE_ID ? 1 : -1));
    if (type !== 0) {
      document.getElementById(`${targetData[0]}-0-${targetData[2]}`).value =
        FinalObj?.MDISC?.toFixed(2);
    }
    if (type !== 1) {
      document.getElementById(`${targetData[0]}-1-${targetData[2]}`).value =
        FinalObj.mPrice?.toFixed(2);
    }
    if (type !== 2) {
      document.getElementById(`${targetData[0]}-2-${targetData[2]}`).value =
        FinalObj.mamt?.toFixed(2);
    }
    // Set the sorted array to the state (assuming you're using React useState)
    setMData(ManageStoneDisc);
  };
  // useEffect(() => {
  //   console.log(Data);
  // }, [Data])
  const submitForm = async (values, page = 1) => {
    setFormval(values);
    setData([]);
    await jwtAuthAxios
      .post("transation/getOutwardTransactionData?page=" + page, values)
      .then((res) => {
        setData(res.data.Data);
        settotalData(res.data.count);
        setDefaultDialoge(false);
      })
      .catch(alert);
  };
  const exporttoexcelData = async (id) => {
    if (SelectedTrID.length > 0) {
      return await Excelexport(SelectedTrID, id);
    } else {
      let confirm = await window.confirm(
        `Are You Sure Download all(${Data.length}) Transaction Data`
      );
      if (confirm) {
        return await Excelexport(
          Data.map((d) => d.FL_BILL_NO),
          id
        );
      } else {
        return false;
      }
    }
  };
  const [editabletrdetail, setEditabletrdetail] = useState(null);
  // useEffect(()=>{
  const saleEditHandler = async ({ trno, trtype }) => {
    // console.log(trno,trtype); return
    setEditabletrdetail(null);
    setEditSaleDialoge(false);
    await jwtAuthAxios
      .post("transation/transactionDetailsforupdate", { trno, trtype })
      .then(
        (res) =>
          // jwtAuthAxios.get(`master/helper?paramsData=SHIPPEDBY&term=1&PVID=Sold&curr=1&tax=VAT_ON_SALES&leadgerdetail=22`).then((resData) => {
          setEditabletrdetail({
            FL_TRANS_NO: res?.data?.data?.mas?.FL_TRANS_NO,
            FL_TRANS_DATE: res?.data?.data?.mas?.FL_TRANS_DATE?.split("T")[0],
            FL_TRANS_TYPE: res?.data?.data?.mas?.FL_TRANS_TYPE,
            FL_PARTY_CODE: res?.data?.data?.mas?.FL_PARTY_CODE,
            FL_BANK_CODE: res?.data?.data?.mas?.FL_BANK_CODE,
            FL_TERM_CODE: res?.data?.data?.mas?.FL_TERM_CODE,
            FL_SHIP_BY: res?.data?.data?.mas?.FL_SHIP_BY,
            FL_CURR_CODE: res?.data?.data?.mas?.FL_CURR_CODE,
            FL_CONV_RATE: res?.data?.data?.mas?.FL_CONV_RATE,
            FL_BILL_NO: res?.data?.data?.mas?.FL_BILL_NO,
            FL_DIAMOND_TYPE: res?.data?.data?.mas?.FL_DIAMOND_TYPE,
            FL_BUSINESS_TYPE: res?.data?.data?.mas?.FL_BUSINESS_TYPE,
            FL_BROKER_PER: res?.data?.data?.mas?.FL_BROKER_PER,
            FL_WAT_PER: res?.data?.data?.mas?.FL_WAT_PER,
            FL_CERTIFICATE_CHARGES:
              res?.data?.data?.mas?.FL_CERTIFICATE_CHARGES,
            FL_DISCOUNT_CHRGES: res?.data?.data?.mas?.FL_DISCOUNT_CHRGES,
            FL_TRACKING_NO: res?.data?.data?.mas?.FL_TRACKING_NO,
            FL_OTHER_CHRGES: res?.data?.data?.mas?.FL_OTHER_CHRGES,
            FL_SHIPING_CHRGES: res?.data?.data?.mas?.FL_SHIPING_CHRGES,
            FL_ADAT_FLG: res?.data?.data?.mas?.FL_ADAT_FLG,
            FL_NARRATION: res?.data?.data?.mas?.FL_NARRATION,
            FL_BROKER_PARTY: res?.data?.data?.mas?.FL_BROKER_PARTY || "",
            is_p: res?.data?.data?.mas?.FL_P == "Y" || false,
            detlist: res?.data?.data?.det,
          }),
        setEditSaleDialoge(true)
        // }).catch(e => {
        //   swal.fire({
        //     icon: 'error',
        //     text: 'Internal server Error',
        //   });
        // })
      );
  };
  // },[])
  const Excelexport = async (Data, id) => {
    let { data } = await jwtAuthAxios.post(
      "trreportexcel/getmemoSalelist?type=" + id,
      {
        BILL_NO: Data,
      }
    );
    return data;
  };
  const columnVirtualizerInstanceRef = useRef(null);
  const table = useMaterialReactTable({
    columnVirtualizerInstanceRef, //optional
    columnVirtualizerOptions: { overscan: 4 }, //optionally customize the virtualizer
    columns: columns, //500 columns
    data: Data || [],
    // enableRowActions: true,
    // enableEditing: true,
    selectAllMode: true,

    // onEditingRowChange: (rowIndexes) => console.log(rowIndexes),
    // enableColumnPinning: true,
    enableColumnResizing: true,
  });
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  return (
    <div>
      <Grid container>
        <Grid item xs={4} sx={{ mb: 2 }}>
          <Typography variant="h2">Transaction History</Typography>
        </Grid>
        <Grid item xs={8} sx={{ mb: 2, textAlign: "end" }}>
          <Stack direction={"row"} sx={{ justifyContent: "end" }} spacing={2}>
            <Button
              sx={{ minWidth: 92 }}
              variant={"contained"}
              size={"small"}
              onClick={() => {
                setSaleReturnStatus(!saleReturnStatus);
              }}
              startIcon={<LoyaltyIcon />}
            >
              Sale Return
            </Button>
            {jumboco?.rights?.export == 1 && (
              <>
                <ExcelTransactionExp
                  onClickf={() => exporttoexcelData(33)}
                  text={"Export Memo Excel"}
                />
                <ExcelTransactionExp
                  onClickf={() => exporttoexcelData(35)}
                  text={"Export Sold Excel"}
                />
              </>
            )}
            {/* <Button sx={{minWidth: 92}}  variant={"contained"} size={"small"} onClick={exporttoexcelData} startIcon={<Download/>}>Export to excel</Button> */}
            <Button
              sx={{ minWidth: 92 }}
              variant={"contained"}
              size={"small"}
              onClick={() => {
                setDefaultDialoge(true);
              }}
              startIcon={<FilterAltOutlinedIcon />}
            >
              Filter
            </Button>
          </Stack>
        </Grid>
      </Grid>

      <SelectTransactionModal
        formval={formval}
        handleSubmit={submitForm}
        setData={setData}
        open={DefaultDialoge}
        handleClose={setDefaultDialoge}
        partyOptions={trParty}
      />
      {saleReturnStatus === true && (
        <Dialog
          open={saleReturnStatus}
          maxWidth={"sm"}
          fullWidth
          margin="0"
          onClose={() => {
            setSaleReturnStatus(false);
          }}
        >
          <DialogTitle>Sales Return</DialogTitle>
          <DialogContent>
            <SaleReturn setSaleReturnStatus={setSaleReturnStatus} />
          </DialogContent>
        </Dialog>
      )}
      <Paper>
        <MaterialReactTable table={table} />
        {/* <DataGrid
        rows={Data || []}
        columns={columns}
        autoHeight
        disableColumnMenu
        showCellRightBorder
        resizable
        rowSelectionModel={SelectedTrID}
        footerRowsPerPageOptions={[50,100,500]}
        onRowSelectionModelChange={(data)=>{setSelectedTrID(data)}}
        density='compact'
        getRowId={(row) => row.FL_BILL_NO}
        // hideFooterPagination 
        checkboxSelection
        // hideFooterSelectedRowCount
        disableRowSelectionOnClick
        // slots={{
        //   footerRowCount: (props) => props,   
        // }}
        // slotProps={{
        //   columnMenu: { background: 'red', counter: Data.length },
        // }}
      
      /> */}
      </Paper>
      {/* {JSON.stringify(totalData)} */}
      <Stack
        direction="row"
        justifyContent={"end"}
        divider={<Divider orientation="vertical" flexItem />}
        spacing={2}
        sx={{ mb: 1, mt: 3 }}
      >
        {totalData?.CONV && (
          <ItemBlock>Conv: {totalData?.CONV?.toFixed(2)}</ItemBlock>
        )}
        {totalData?.RAP && (
          <ItemBlock>Rap: {totalData?.RAP?.toFixed(2)}</ItemBlock>
        )}
        {totalData?.WGT && (
          <ItemBlock>
            Disc:{" "}
            {(
              100 -
              ((totalData?.AMT1 / totalData?.WGT) * 100) / totalData?.RAP
            )?.toFixed(2)}
          </ItemBlock>
        )}
        {totalData?.WGT && <ItemBlock>Total Pcs: {totalData?.PCS}</ItemBlock>}
        {totalData?.WGT && <ItemBlock>Total CTS: {totalData?.WGT}</ItemBlock>}
        {totalData?.WGT && (
          <ItemBlock>
            Price/cts: {(totalData?.AMT1 / totalData?.WGT)?.toFixed(2)}
          </ItemBlock>
        )}
        {totalData?.AMT1 && (
          <ItemBlock>Total AMT($): {totalData?.AMT1?.toFixed(2)}</ItemBlock>
        )}
        {totalData?.AMT2 && (
          <ItemBlock>
            Total AMT({jumboco?.curr?.cd}): {totalData?.AMT2?.toFixed(2)}
          </ItemBlock>
        )}
      </Stack>
      {editabletrdetail && (
        <EditSaleTXN
          trParty={trParty}
          open={EditSaleDialoge}
          setOpen={setEditSaleDialoge}
          editabletrdetail={editabletrdetail}
          setEditabletrdetail={setEditabletrdetail}
        />
      )}

      {/* {Data?.map(trData => <DetailMas Data={trData}/>)} */}

      {/* <Grid container>
        <Grid item xs={5} sx={{ mb: 2 }}>
          <Typography variant='h2'>Party Transaction</Typography>
        </Grid>
        <Grid item xs={4}>
          <Stack direction="row" spacing={2}>
        <TextField
            label="Start Date"
            name="StartDate"
            variant="outlined"
            margin="normal"
            fullWidth
            type='date'
            autoFocus
          />
        <TextField
            label="End Date"
            name="EndDate"
            variant="outlined"
            margin="normal"
            fullWidth
            type='date'
            autoFocus
          /></Stack>
        </Grid>
        <Grid item xs={3}>
          <FormControl sx={{ mb: 2, display: 'block', marginLeft: 'auto', width: 'fit-content' }}>
            <InputLabel>Select Party</InputLabel>
            <Select sx={{ width: 200 }} value={selectedtrParty} label={"Select Party"} onChange={e => { setSelectedTrParty(e.target.value); setValue(value || 33) }}>
              {trParty.map((trParty) => (
                <MenuItem key={trParty.FL_PARTY_CODE} value={trParty.FL_PARTY_CODE}>
                  {trParty.FL_PARTY_NAME}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid> */}
      {/* {selectedtrParty && <Div sx={{ width: '100%' }}>
        <Grid container sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <Grid item>
            <Div sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={(event, newValue) => { setValue(newValue); }}>
                <Tab label="Memo" value={33} {...a11yProps(0)} />
                <Tab label="Sales" value={35} {...a11yProps(1)} />
              </Tabs>
            </Div>
          </Grid>
          {value == 33 && <Grid item>
            <Button variant='contained'  sx={{ mr: 1 }} disabled={!selectedMemoNo} onClick={()=>{window.open(BACKEND_APP_URL+'rp/GenerateMemo?memono='+selectedMemoNo)}}>Download Memo</Button>
            <FormControl sx={{ mb: 2, mr: 2, width: 'fit-content' }}>
              <InputLabel size='small' >{Memonumber?.length > 0 ? 'Select Memo Number' : 'Loading...'}</InputLabel>
              <Select sx={{ width: 200 }} disabled={!Memonumber?.length > 0} size='small' value={selectedMemoNo} label={"Select Memo Number"} onChange={e => { setSelectedMemoNo(e.target.value); setValue(value || 33) }}>
                {Memonumber?.map((number) => (
                  <MenuItem key={number.FL_TRANS_NO} value={number.FL_TRANS_NO}>
                    Memo: {number.FL_TRANS_NO}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
        
            <Button variant='contained' disabled={SelectedStone?.length <= 0} onClick={memoReturnHandler} color='primary'>Memo Return</Button>
            <Button variant='contained' disabled={SelectedStone?.length <= 0} onClick={() => setOpen(!open)} sx={{ ml: 1 }} color='primary'>Memo To Sold</Button>
          </Grid>}
        </Grid>
        <TabPanel value={33} index={value}>{MData == null && selectedMemoNo != null ? <TableSkeleton /> : MData?.length > 0 ? <>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} size='small' aria-label="Status table">
              <TableHead>
                <TableRow>
                  <TableCell><Checkbox
                    checked={MData?.length == SelectedStone?.length}
                    onClick={(e) => {
                      if (e.target.checked) {
                        let FilterMData = MData?.filter((row, index) => row.STATUS == 'MEMO')
                        let stonMData = FilterMData?.map((row, index) => row.FL_STONE_ID)
                        stonMData ? setSelectedStone(stonMData) : setSelectedStone([])
                      } else {
                        setSelectedStone([])
                      }
                    }}
                  /></TableCell>
                  <TableCell align="center">STATUS</TableCell>
                  <TableCell align="center">StoneId</TableCell>
                  <TableCell align="center">Lab</TableCell>
                  <TableCell align="center">ReportNO</TableCell>
                  <TableCell align="center">Shape</TableCell>
                  <TableCell align="center">CARATS</TableCell>
                  <TableCell align="center">Color</TableCell>
                  <TableCell align="center">Clarity</TableCell>
                  <TableCell align="center">RapPrice($)</TableCell>
                  <TableCell align="center">Disc</TableCell>
                  <TableCell align="center">Amt\cts</TableCell>
                  <TableCell align="center">Sale Amt($)</TableCell>
                  <TableCell align="center">Sale Amt({jumboco?.curr?.cd})</TableCell>
                  <TableCell align="center">Kept</TableCell>
                  <TableCell align="center">Return</TableCell>
                </TableRow>
              </TableHead>
              {MData?.map((stone, t) => <TableBody sx={{backgroundColor:`${stone.FL_RET_CTS  == stone.CARATS? '#e7314521' :stone.FL_KEPT_CTS  == stone.CARATS ? '#00800017':'initial'}`}} key={t}>
                <TableCell><Checkbox disabled={stone.STATUS != 'MEMO'} checked={SelectedStone.includes(stone.FL_STONE_ID)} onClick={() => { handleStoneSelect(stone.FL_STONE_ID) }} /></TableCell>
                <TableCell align="center">{stone.STATUS}</TableCell>
                <TableCell align="center">{stone.FL_STONE_ID}</TableCell>
                <TableCell align="center">{stone.FL_LAB}</TableCell>
                <TableCell align="center">{stone.FL_CERTIFICATENO}</TableCell>
                <TableCell align="center">{stone.SHAPE}</TableCell>
                <TableCell align="center">{stone.CARATS}</TableCell>
                <TableCell align="center">{stone.COLOR}</TableCell>
                <TableCell align="center">{stone.FL_CLARITY}</TableCell>
                <TableCell align="center">{stone.FL_RAP_PRICE_US}</TableCell>
                <TableCell align="center">
                  {stone.STATUS == 'MEMO'? <TextField size='small' type='number' id={`input-0-${t}`} min={0} max={100} sx={{ minWidth: 150 }} onBlur={(e) => handlediscChang(e, stone, 0)} defaultValue={Number(stone.MDISC).toFixed(2)} /> : stone.MDISC?.toFixed(2)}
                   
                </TableCell>
                <TableCell align="center">
                {stone.STATUS == 'MEMO'? <TextField size='small' type='number' id={`input-1-${t}`} min={0} sx={{ minWidth: 150 }} onBlur={(e) => handlediscChang(e, stone, 1)} defaultValue={Number(stone.mPrice || (stone.FL_RAP_PRICE_US - (stone.FL_RAP_PRICE_US * (stone.MDISC)) / 100)).toFixed(2)} /> : stone.FL_SALERATE?.toFixed(2) }
                </TableCell>
                <TableCell align="center">
                  {stone.STATUS == 'MEMO'? <TextField size='small' type='number' id={`input-2-${t}`} min={0} sx={{ minWidth: 150 }} onBlur={(e) => handlediscChang(e, stone, 2)} defaultValue={Number(stone.mamt || ((stone.FL_RAP_PRICE_US - (stone.FL_RAP_PRICE_US * (stone.MDISC)) / 100) * stone.CARATS)).toFixed(2)} /> : stone.FL_AMT1?.toFixed(2)} 
                </TableCell>
                <TableCell align="center">{(jumboco?.curr?.cd +''+ (jumboco?.curr?.Rate *(Number(stone.mamt || ((stone.FL_RAP_PRICE_US - (stone.FL_RAP_PRICE_US * (stone.MDISC)) / 100) * stone.CARATS)))).toFixed(2))}</TableCell>
                <TableCell align="center">{stone.FL_KEPT_CTS  == stone.CARATS ? <CheckBoxOutlinedIcon/> : '-'}</TableCell>
                <TableCell align="center">{stone.FL_RET_CTS  == stone.CARATS ? <CheckBoxOutlinedIcon/> : '-'}</TableCell>
              </TableBody>)}
            </Table>
          </TableContainer>
        </> : <NoDataPlaceholder />}</TabPanel>
        <TabPanel value={35} index={value}>
        {Data && <TableView body={Data} actions={currentType == 'DETAIL' ? (row) => (
          <div>
            <Button onClick={() => {handleDetailView(row)}}><RemoveRedEye /></Button>
          </div>
        ) : (row) => false} />}
          </TabPanel>
        <ShippingFormMemoTOSOLDDialog SelectedStoneDetail={SelectedStoneDetail} selectedMemoNo={selectedMemoNo} Data={MData} open={open} handleClose={handleClose} callBack={fetchtrdata} SelectedStone={SelectedStone} userSelectedParty={selectedtrParty} />
      </Div>} */}
    </div>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {/* {value === index && ( */}
      <Div sx={{ p: 3 }}>
        <Typography>{children}</Typography>
      </Div>
      {/* )} */}
    </div>
  );
}

// const ShippingFormMemoTOSOLDDialog = ({ SelectedStoneDetail, SelectedStone, Data, userSelectedParty, open, handleClose, callBack, selectedMemoNo }) => {
//   const [helperdata, setHelperdata] = useState([])
//   const [ButtonLoadng, setButtonLoadng] = useState(false)
//   const [stoneDataDetail, setStoneDataDetail] = useState(null)
//   const [CurrencyName, setCurrencyName] = useState(null)
//   const swal = useSwalWrapper()
//   useEffect(() => {
//     let TMPOBJ = {
//       pcs: SelectedStoneDetail?.length,
//       cts: SelectedStoneDetail?.reduce((acc, obj) => acc + obj.CARATS, 0),
//       disc: ((SelectedStoneDetail?.reduce((acc, obj) => acc + Number(obj.MDISC), 0)) / SelectedStoneDetail?.length),
//       rap: (SelectedStoneDetail?.reduce((acc, obj) => acc + obj.RAP_PRICE, 0) / SelectedStoneDetail?.length)
//     }
//     console.log(Data);
//     setStoneDataDetail({ ...TMPOBJ, price: (TMPOBJ?.rap - ((TMPOBJ?.rap * TMPOBJ?.disc) / 100)) })
//   }, [SelectedStoneDetail, Data])
//   const handleSubmit = async (values, { resetForm }) => {
//     // Handle form submission logic here
//     if (values.term && values.FL_CURR_CODE && values.FL_CURR_CODE) {
//       setButtonLoadng(true)
//       // resetForm();
//       // let fData = Data?.filter((st) => SelectedStone.includes(st.FL_STONE_ID))
//       await jwtAuthAxios.post(`transation/polishOutward`, { ...values, Party: userSelectedParty, transactionType: helperdata.PVID, StoneData: SelectedStoneDetail, isDetail: 'Y', isMemo: 'Y', "trno": selectedMemoNo }).then((res) => {
//         swal.fire({
//           icon: 'success',
//           text: res.data.message,
//         });
//         resetForm();
//         callBack()
//         handleClose();
//       }).catch(e => {
//         swal.fire({
//           icon: 'error',
//           text: 'Internal server Error',
//         });
//       }).finally(() => {
//         setButtonLoadng(false)
//       })
//     } else {
//       swal.fire({
//         icon: 'error',
//         text: 'Please Fill Detail',
//       });
//     }
//   };
//   const jumboco = useJumboAuth();
//   const [initialValues,setInitialValues] = useState({
//     shippingNumber: '',
//     term: '',
//     shipBy: '',
//     wat_per: helperdata?.TAX?.FL_TAX_PER ||0,
//     ShipingCharge: '',
//     CertCharge: '',
//     OtherCharge: '',
//     Discount: '',
//     narration:'',
//     FL_CURR_CODE: '2',
//     FL_CONV_RATE: jumboco?.curr?.Rate,
//   });
//   useEffect(()=>{
//     setInitialValues({...initialValues,wat_per: helperdata?.TAX?.FL_TAX_PER})
//   },[helperdata])
//   useEffect(() => {
//     jwtAuthAxios.get(`master/helper?paramsData=SHIPPEDBY&term=1&PVID=Sold&curr=1&tax=Vat`).then((res) => {
//       setHelperdata(res.data?.data)
//     }).catch(e => {
//       swal.fire({
//         icon: 'error',
//         text: 'Internal server Error',
//       });
//     })
//     // fetchBasketdata();
//   }, []);
//   const Item = styled(Paper)(({ theme }) => ({
//     backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
//     ...theme.typography.body2,
//     padding: theme.spacing(1),
//     textAlign: 'center',
//     color: theme.palette.text.secondary,
//   }));
//   return (
//     <Dialog open={open} sx={{ minWidth: '650px' }} onClose={handleClose}>
//       <DialogTitle>Sold Shipping Information</DialogTitle>
//       <DialogContent >
//         <Formik initialValues={initialValues} onSubmit={handleSubmit}>
//           {({ handleSubmit, values,setFieldValue }) => (
//             <Form onSubmit={handleSubmit} >
//               <Grid container spacing={2}>
//                 <Grid item lg={6}>
//                   <Field name="FL_CURR_CODE" as={TextField} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} select label="Currency Type" fullWidth>
//                     {helperdata?.CURR?.map((option) => (
//                       <MenuItem key={option.FL_CURRENCY_ID} onClick={(e) => { setCurrencyName(option.FL_CURRENCY_NAME) }} fname={option.FL_CURRENCY_NAME} value={option.FL_CURRENCY_ID}>
//                         {option.FL_CURRENCY_NAME}
//                       </MenuItem>
//                     ))}
//                   </Field>
//                 </Grid>
//                 <Grid item lg={6}>
//                   <Field name="FL_CONV_RATE" as={TextField} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} type="number" label="Conv Rate" fullWidth />
//                 </Grid>
//               </Grid>
//               <Field name="term" as={TextField} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} style={{ margin: '5px 0' }} select label="Payment Term" fullWidth>
//                 {helperdata?.TERM?.map((option) => (
//                   <MenuItem key={option.FL_TERM_CODE} color='primary' value={option.FL_TERM_CODE}>
//                     {option.FL_TERM_NAME}
//                   </MenuItem>
//                 ))}
//               </Field>
//               <Field name="shipBy" as={TextField} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} select label="Ship By" fullWidth>
//                 {helperdata?.SHIPPEDBY?.map((option) => (
//                   <MenuItem key={option.FL_PARA_VALUE} value={option.FL_GPID}>
//                     {option.FL_PARA_VALUE}
//                   </MenuItem>
//                 ))}
//               </Field>
//               <Grid container columnSpacing={2}>
//                 <Grid item lg={6}>
//                   <Field name="wat_per" disabled={values.is_p == true}  as={TextField} type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="Vat Charge(%)" fullWidth />
//                 </Grid>
//                 <Grid item lg={6}>
//                   <Field name="ShipingCharge" as={TextField} type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="Shiping Charge(AMT)" fullWidth />
//                 </Grid>
//                 <Grid item lg={6}>
//                   <Field name="CertCharge" as={TextField} type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="Cert. Charge(AMT)" fullWidth />
//                 </Grid>
//                 <Grid item lg={6}>
//                   <Field name="OtherCharge" as={TextField} type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="OtherCharge(AMT)" fullWidth />
//                 </Grid>
//                 <Grid item lg={6}>
//                   <Field name="Discount" as={TextField} type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="Discount(-AMT)" fullWidth />
//                 </Grid>
//                 <Grid item lg={6}>
//                   <Field name="shippingNumber" InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} as={TextField} style={{ margin: '5px 0' }} label="Shipping Number" fullWidth />
//                 </Grid>
//               </Grid>
//               <InputLabel>Naration</InputLabel>
//                 <Field size="small"
//                       component={TextareaAutosize}
//                       name="narration"
//                       label="Naration"
//                       minRows={3}
//                       onChange={(e)=>setFieldValue( 'narration', e.target.value)}
//                       style={{width:'100%'}}
//                       fullWidth
//                       />
//               <Field
//                 name="is_p"
//                 render={({ field }) => (
//                   <FormControlLabel
//                     control={
//                       <Checkbox
//                         {...field}
//                         style={{ margin: '5px 0' }}
//                         onClick={()=>!values.is_p ? setFieldValue('wat_per', 0):setFieldValue('wat_per', helperdata?.TAX?.FL_TAX_PER)}
//                         size="small"
//                       // Add any other Checkbox props here
//                       />
//                     }
//                     label="IS P"
//                     fullWidth
//                   />
//                 )}
//               />
//               <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2} sx={{ mb: 1 }} >
//                 <Item>Pcs  {stoneDataDetail?.pcs || 0}</Item>
//                 <Item>CTS  {stoneDataDetail?.cts?.toFixed(2) || 0.00}</Item>
//                 <Item>Rap  {stoneDataDetail?.rap.toFixed(2) || 0}</Item>
//                 <Item>Disc%  {stoneDataDetail?.disc?.toFixed(2) || 0}</Item>
//                 <Item>vat%  {values.wat_per || 0}</Item>
//               </Stack>
//               <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2} sx={{ mb: 1 }} >
//                 <Item>ShipingCharge ($AMT) = {values.ShipingCharge || 0}</Item>
//                 <Item>OtherCharge ($AMT) = {values.OtherCharge || 0}</Item>
//                 <Item>CertCharge ($AMT) = {values.CertCharge || 0}</Item>
//                 <Item>Disc($AMT) = (-{values.Discount || 0})</Item>
//               </Stack>
//               <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2} sx={{ mb: 1 }} >
//                 <Item>Price/cts($) = {(stoneDataDetail?.price + ((stoneDataDetail?.price * values.wat_per) / 100))?.toFixed(2) || 0}</Item>
//                 <Item>Total Amt ($) = {((stoneDataDetail?.price + ((stoneDataDetail?.price * values.wat_per) / 100) + values.CertCharge + values.OtherCharge + values.ShipingCharge - values.Discount) * stoneDataDetail?.pcs)?.toFixed(2) || 0}</Item>
//                 <Item>Total Amt ({CurrencyName}) = {(((stoneDataDetail?.price + ((stoneDataDetail?.price * values.wat_per) / 100) + values.CertCharge + values.OtherCharge + values.ShipingCharge - values.Discount) * values.FL_CONV_RATE) * stoneDataDetail?.pcs)?.toFixed(2) || 0}</Item>
//               </Stack>
//               <LoadingButton loading={ButtonLoadng} variant="contained" color='primary' sx={{ display: 'block', marginLeft: 'auto', mt: 3 }} type="submit">Sold</LoadingButton>
//             </Form>
//           )}
//         </Formik>
//       </DialogContent>
//     </Dialog>
//   );
// };

const SelectTransactionModal = ({
  formval,
  open,
  handleClose,
  partyOptions,
  setData,
  handleSubmit,
}) => {
  return (
    <Dialog open={open} maxWidth={"sm"} onClose={handleClose}>
      <DialogTitle>Search OutWard</DialogTitle>
      <DialogContent>
        <Formik
          initialValues={formval}
          onSubmit={async (values) => {
            await handleSubmit(values);
            // Handle form submission
            // console.log(values);
          }}
        >
          {({ values, handleChange, setValues }) => (
            <Form>
              {/* <InputLabel id="select-party-label">Select Partys</InputLabel> */}
              {/* <Field
                  name="selectedParties"
                  as={Select}
                  labelId="select-party-label"
                  multiple
                  fullWidth
                  value={values.selectedParties}
                  onChange={handleChange}
                  label="Select Partys"
                  renderValue={(selected) => (
                    <Div sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
                        {partyOptions.filter(p =>selected.includes(p.FL_PARTY_CODE)).map((value) => (
                            <Chip key={value.FL_PARTY_CODE} label={value.FL_PARTY_NAME}/>
                        ))}
                    </Div>
                )}
                >
                  {partyOptions.map((party) => (
                    <MenuItem key={party.FL_PARTY_CODE} value={party.FL_PARTY_CODE}>
                      {party.FL_PARTY_NAME}
                    </MenuItem>
                  ))}
                </Field> */}
              {partyOptions?.PARTY?.length > 1 && (
                <FormControl fullWidth sx={{ marginBottom: 1, mt: 2 }}>
                  <Autocomplete
                    multiple
                    id="PartyId"
                    onChange={(event, newValue) => {
                      setValues({
                        ...values,
                        selectedParties: newValue.map(
                          (obj) => obj.FL_PARTY_CODE
                        ),
                      });
                    }}
                    options={partyOptions?.PARTY || []}
                    getOptionLabel={(option) => option.FL_PARTY_NAME}
                    defaultValue={partyOptions?.PARTY?.filter((p) =>
                      values.selectedParties.includes(p.FL_PARTY_CODE)
                    )}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.FL_PARTY_NAME}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        // variant="standard"
                        label="Select Party"
                        placeholder="Type Name"
                      />
                    )}
                  />
                </FormControl>
              )}
              <Grid container spacing={2}>
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    margin="normal"
                    type="date"
                    label="Start Date"
                    name="startDate"
                    value={values.startDate}
                    InputLabelProps={{ shrink: true }}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    margin="normal"
                    type="date"
                    label="End Date"
                    InputLabelProps={{ shrink: true }}
                    name="endDate"
                    value={values.endDate}
                    onChange={handleChange}
                  />
                </Grid>

                {Array.isArray(partyOptions?.SALESMAN) &&
                  partyOptions?.SALESMAN.length > 0 && (
                    <Grid item xs={12}>
                      <FormControl fullWidth margin="normal" sx={{ mt: 0 }}>
                        <Autocomplete
                          multiple
                          id="salesmanData-type"
                          options={partyOptions?.SALESMAN || []}
                          disableCloseOnSelect
                          // onChange={handleChange}
                          onChange={(event, newValue) => {
                            setValues({
                              ...values,
                              salesmanData: newValue.map(
                                (obj) => obj.FL_USER_ID
                              ),
                            });
                          }}
                          defaultValue={partyOptions?.SALESMAN?.filter((p) =>
                            values.salesmanData.includes(p.FL_USER_ID)
                          )}
                          getOptionLabel={(option) => option.FL_NAME}
                          renderOption={(props, option, { selected }) => (
                            <li {...props}>{option.FL_NAME}</li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Salesman "
                              placeholder="..."
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>
                  )}
                <Grid item xs={12}>
                  <FormControl fullWidth margin="normal" sx={{ mt: 0 }}>
                    {/* <InputLabel id="transaction-type-label">Transaction Type</InputLabel> */}
                    {/* <Select
                  labelId="transaction-type-label"
                  label="Transaction Type"
                  name="transactionType"
                  value={values.transactionType}
                  onChange={handleChange}
                >
                  <MenuItem value="Type 1">Type 1</MenuItem>
                  <MenuItem value="Type 2">Type 2</MenuItem>
                </Select> */}

                    <Autocomplete
                      multiple
                      id="TR-type"
                      options={partyOptions?.TRANSATION_TYPE || []}
                      disableCloseOnSelect
                      // onChange={handleChange}
                      onChange={(event, newValue) => {
                        setValues({
                          ...values,
                          transactionType: newValue.map((obj) => obj.FL_GPID),
                        });
                      }}
                      defaultValue={partyOptions?.TRANSATION_TYPE?.filter((p) =>
                        values.transactionType.includes(p.FL_GPID)
                      )}
                      getOptionLabel={(option) => option.FL_PARA_VALUE}
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.FL_PARA_VALUE}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Transaction Type"
                          placeholder="..."
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth margin="normal" sx={{ mt: 0 }}>
                    {/* <InputLabel id="transaction-type-label">Transaction Type</InputLabel> */}
                    {/* <Select
                  labelId="transaction-type-label"
                  label="Transaction Type"
                  name="transactionType"
                  value={values.transactionType}
                  onChange={handleChange}
                >
                  <MenuItem value="Type 1">Type 1</MenuItem>
                  <MenuItem value="Type 2">Type 2</MenuItem>
                </Select> */}

                    <Autocomplete
                      multiple
                      id="inv-type"
                      options={partyOptions?.INVETORYTYPE || []}
                      disableCloseOnSelect
                      // onChange={handleChange}
                      onChange={(event, newValue) => {
                        // console.log(newValue);
                        setValues({
                          ...values,
                          INVETORYTYPE: newValue?.map((obj) => obj["NAME"]),
                        });
                      }}
                      defaultValue={partyOptions?.INVETORYTYPE?.filter((p) =>
                        values.INVETORYTYPE?.includes(p.NAME)
                      )}
                      getOptionLabel={(option) => option?.NAME}
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option?.NAME}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Inventory Type"
                          placeholder="..."
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
              </Grid>

              {/* <Grid item md={6} xs={12}> */}
              {Array.isArray(partyOptions?.SALESMAN) &&
                partyOptions?.SALESMAN.length > 0 && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        value={values.fl_p}
                        defaultChecked={values.fl_p}
                        onChange={handleChange}
                        name="fl_p"
                        style={{ margin: "5px 0" }}
                        size="small"
                      />
                    }
                    label="IS P"
                    fullWidth
                  />
                )}
              {/* </Grid> */}
              <DialogActions>
                {/* <Button onClick={handleClose}>Cancel</Button> */}
                <Button type="submit" color="primary" variant="contained">
                  Search
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

const DetailMas = ({ Data }) => {
  const Item = styled(Span)(({ theme }) => ({
    padding: theme.spacing(0, 1),
  }));
  return (
    <Card sx={{ mb: 1 }}>
      <Stack
        direction={"row"}
        alignItems={"center"}
        sx={{ p: (theme) => theme.spacing(2, 1) }}
      >
        <Item
          sx={{
            flex: { xs: 1, md: "0 1 45%", lg: "0 1 35%" },
          }}
        >
          <Stack direction={"row"} alignItems={"center"}>
            {/* <Item sx={{ml: -1}}>
                          <JumboBookmark value={Data?.isFavorite} sx={{verticalAlign: 'middle'}}/>
                      </Item> */}
            <Item>
              <Badge
                overlap="circular"
                variant="dot"
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                sx={{
                  ".MuiBadge-badge": {
                    border: "2px solid #FFF",
                    height: "14px",
                    width: "14px",
                    borderRadius: "50%",
                    bgcolor:
                      Data?.FL_P == "Y"
                        ? "#757575"
                        : Data.TRTYPE[0] == "M"
                        ? "info.main"
                        : "success.main",
                  },
                }}
              >
                <Avatar
                  sx={{
                    width: 56,
                    height: 56,
                  }}
                  // alt={`${Data?.firstName}
                  // ${Data?.lastName}`}
                  // src={Data?.profilePic}
                >
                  {Data.TRTYPE[0]}
                </Avatar>
              </Badge>
            </Item>
            <Item>
              <Typography variant={"h6"} mb={0.5}>
                Party Name: {Data?.PARTYNAME}
              </Typography>
              <Typography variant={"h6"} color="text.secondary" mb={0.5}>
                Term: {Data?.TERM}{" "}
              </Typography>
            </Item>
          </Stack>
        </Item>
        <Item
          sx={{
            alignSelf: "flex-start",
            flexBasis: { md: "28%", lg: "18%" },
            display: { xs: "none", md: "block" },
          }}
        >
          {Data?.FL_TRANS_TYPE == "33" ? (
            <Link
              to={`/outward/${Data?.FL_TRANS_TYPE}/${Data?.FL_PARTY_CODE}/${Data?.FL_TRANS_NO}`}
              target="_blank"
            >
              NO: {Data?.FL_BILL_NO}
            </Link>
          ) : (
            <Typography variant={"body1"}>NO: {Data?.FL_BILL_NO}</Typography>
          )}
          <Typography variant={"body1"} color="text.secondary">
            Rate : {Data?.FL_CONV_RATE}
          </Typography>
          <Typography variant={"body1"} color="text.secondary" mb={0.5}>
            Ship: {Data?.SHIP}{" "}
          </Typography>
        </Item>
        <Item
          sx={{
            flexBasis: "30%",
            // display: {xs: 'none', lg: 'block'}
          }}
        >
          <Stack
            spacing={2}
            direction={"row"}
            alignItems={"center"}
            sx={{ textAlign: "center" }}
          >
            <Item>
              <Typography variant={"h6"} mb={0.5}>
                {Data?.PCS}
              </Typography>
              <Typography variant={"body1"} color="text.secondary">
                PCS
              </Typography>
            </Item>
            <Item>
              <Typography variant={"h6"} mb={0.5}>
                {Data?.CTS || "-"}
              </Typography>
              <Typography variant={"body1"} color="text.secondary">
                CTS
              </Typography>
            </Item>
            <Item>
              <Typography variant={"h6"} mb={0.5}>
                {Data?.FL_AMT1?.toFixed(2)}
              </Typography>
              <Typography variant={"body1"} color="text.secondary">
                $
              </Typography>
            </Item>
            <Item>
              <Typography variant={"h6"} mb={0.5}>
                {Data?.FL_AMT2?.toFixed(2)}
              </Typography>
              <Typography variant={"body1"} color="text.secondary">
                {Data?.CURR}
              </Typography>
            </Item>
          </Stack>
        </Item>
        <Item
          sx={{
            ml: "auto",
          }}
        >
          {" "}
          <Typography variant={"h6"} mb={0.5}>
            Date: {Data?.TRDATE}
          </Typography>
          {Data.TRTYPE == "Memo" ? (
            <Button
              sx={{ minWidth: 92 }}
              onClick={() => {
                window.open(
                  BACKEND_APP_URL + "rp/GenerateMemo?memono=" + Data.FL_TRANS_NO
                );
              }}
              disableElevation
              variant={"contained"}
              size={"small"}
            >
              Memo PDF
            </Button>
          ) : Data.TRTYPE == "Sold" ? (
            <Button
              sx={{ minWidth: 92 }}
              onClick={() => {
                window.open(
                  BACKEND_APP_URL +
                    "rp/GenerateInvoice?INNO=" +
                    Data.FL_TRANS_NO
                );
              }}
              disableElevation
              variant={"contained"}
              size={"small"}
            >
              Invoice
            </Button>
          ) : null}
        </Item>
        {/* <Item sx={{ml: {xs: 'auto', sm: 0}}}>
                  <IconButton aria-label="settings">
                      <MoreHorizIcon/>
                  </IconButton>
              </Item> */}
      </Stack>
    </Card>
  );
};
PartStoneStatus.Modulename = "outward";
export default PartStoneStatus;
